import { User } from '@/api/models/User';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { oktaAuth } from '@/components/pages/LoginPage/index';

export interface AuthState {
  user: null | User;
  token: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.loading = false;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: () => {
      (() => {
        localStorage.removeItem('auth_token');
        oktaAuth.signOut().catch((err: unknown) => console.log(err));
      })();
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout } = authSlice.actions;
export default authSlice.reducer;
